export default __webpack_public_path__ + "static/media/deped.416429d8.png";